module.exports = __webpack_public_path__ + "img/hotel.20eb6c07.jpg";